import { DocumentNode } from '@apollo/client';
import { useEffect, useState } from 'react';
import { CategoryResponse, CmsCategory } from '../models/ResourcesCategory';
import { cmsGraphql } from '../http/cms_graphql';

const CATEGORY_DISPLAY_FIRST: string[] = ['Getting Started'];

export const formatCategoriesWithBullet = (
  value: CmsCategory[] | null | undefined,
) => {
  if (value == null) {
    return '';
  }
  const category = value.map((category) => category.name);
  return category.join(' • ');
};

export const useFetchCategory = (
  query: DocumentNode,
  allCategoryTitle?: string,
) => {
  const [categories, setCategories] = useState<CmsCategory[]>([]);

  useEffect(() => {
    const sortCategories = (value: CmsCategory[] | null) => {
      if (value === null) {
        return [];
      }
      let allCategoryItem;
      if (allCategoryTitle) {
        allCategoryItem = {
          databaseId: -1,
          name: allCategoryTitle,
          slug: allCategoryTitle.toLowerCase(),
        };
      }

      let items: CmsCategory[];
      if (allCategoryTitle?.toLowerCase() === 'all articles') {
        items = value.filter((elm) => elm.slug != 'uncategorized');
        items.sort((item1, item2) => {
          if (item1.name === null || item2.name === null) {
            return 0;
          }
          const itemIndex1 = CATEGORY_DISPLAY_FIRST.indexOf(item1.name);
          const itemIndex2 = CATEGORY_DISPLAY_FIRST.indexOf(item2.name);
          if (itemIndex1 >= 0 && itemIndex2 >= 0) {
            return itemIndex1 - itemIndex2;
          } else if (itemIndex1 >= 0 || itemIndex2 >= 0) {
            return itemIndex2 - itemIndex1;
          }
          return item1.name.localeCompare(item2.name);
        });
      } else {
        items = value;
      }

      if (allCategoryItem) {
        return [allCategoryItem, ...items];
      }
      return [...items];
    };

    const fetchCategories = async () => {
      const result = await cmsGraphql.query<CategoryResponse>({
        query,
      });
      if (result.data.categories) {
        setCategories(sortCategories(result.data.categories.nodes));
      } else if (result.data.eventsCategories) {
        setCategories(sortCategories(result.data.eventsCategories.nodes));
      }
    };
    fetchCategories();
  }, [allCategoryTitle, query]);

  return categories;
};
